import { Stack } from "expo-router";
import { useThemeColors } from "@/providers/ThemeProvider";

/**
 * Sudoku Game Layout
 * @description Nested stack navigator for Sudoku game screens
 */
export default function SudokuLayout() {
  const colors = useThemeColors();

  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: { backgroundColor: colors.background },
        animation: "slide_from_right",
      }}
    >
      <Stack.Screen name="index" />
      <Stack.Screen name="[sessionId]" />
    </Stack>
  );
}

